import { ValidatorFunction } from '../../interface/validator-function.type';
import { isDraftEmpty } from '../draft/is-draft-empty.util';

export const draftRequiredValidator: (messageKey: string, messageProps?: string[]) => ValidatorFunction = (messageKey, messageProps = []) => (value) => {
  return [ {
    isValid: !isDraftEmpty(value),
    messageKey, messageProps
  } ];
};